import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';

// Não instrumentar rotas públicas (sem sessão, sem "módulo" real pra medir).
const ROTAS_PUBLICAS = ['/login', '/forgot-password', '/reset-password', '/accept-invite'];

// Fase 2 da migração de rotas (docs/MIGRACAO_ROTAS.md): registra acesso por
// módulo/rota em audit_log, pra fechar a lacuna que impediu um veredito
// definitivo na auditoria de Individual/Lote (sem depender de logs do Nginx).
function useTelemetriaAcesso() {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const ultimoRegistrado = useRef(null);

  useEffect(() => {
    const path = location.pathname;

    if (!isAuthenticated || ROTAS_PUBLICAS.includes(path)) {
      return;
    }
    // Dedupe: mesma rota não gera evento repetido (ex.: StrictMode em dev
    // invoca efeitos duas vezes; re-render sem troca de rota não deve contar).
    if (ultimoRegistrado.current === path) {
      return;
    }
    ultimoRegistrado.current = path;

    // Fire-and-forget: telemetria nunca pode bloquear ou quebrar a navegação.
    api
      .post('/telemetria/acesso-modulo', { modulo: path })
      .catch((err) => console.error('telemetria acesso-modulo:', err));
  }, [location.pathname, isAuthenticated]);
}

export default useTelemetriaAcesso;
